module.exports = __webpack_public_path__ + "static/media/contact.b7b92be6.jpg";